import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

// Silence harmless ResizeObserver loop warnings from Radix UI / Shadcn
const ignoreResizeObserverError = (e) => {
  const msg = e?.message || e?.reason?.message || "";
  if (typeof msg === "string" && msg.startsWith("ResizeObserver loop")) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return true;
  }
};
window.addEventListener("error", ignoreResizeObserverError);
window.addEventListener("unhandledrejection", ignoreResizeObserverError);

// ---------------------------------------------------------------------------
// Root router — three bundles, ONE codebase
// ---------------------------------------------------------------------------
//   1. Path "/"                → redirect to /site/ (marketing bundle)
//   2. Path /book or /book/*   → mount web SPA (booking flow)
//   3. Path /m or /m/*         → mount mobile bundle
//   4. Capacitor native        → mount mobile bundle
//   5. All other SPA routes    → mount web SPA (payment-success, /login,
//                                /account, /company/*, /admin, /panpay/:id,
//                                /verify/:id, etc.)
// ---------------------------------------------------------------------------
const isNative = (() => {
  try {
    return !!(
      window.Capacitor &&
      window.Capacitor.isNativePlatform &&
      window.Capacitor.isNativePlatform()
    );
  } catch { return false; }
})();

const path = typeof window !== "undefined" ? window.location.pathname : "";

// 1) marketing site → clean redirect at root
if (!isNative && (path === "" || path === "/")) {
  window.location.replace("/site/" + window.location.search + window.location.hash);
}

const isMobilePath = path === "/m" || path.startsWith("/m/");
const useMobile = isNative || isMobilePath;

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

if (!isNative && (path === "" || path === "/")) {
  // waiting for redirect — do not mount to avoid a flash of blank white
} else if (useMobile) {
  if (!isNative && path === "/m") {
    window.history.replaceState(null, "", "/m/");
  }
  import("./mobile/MobileApp").then(({ default: MobileApp }) => {
    root.render(<React.StrictMode><MobileApp/></React.StrictMode>);
  });
} else {
  import("./App").then(({ default: App }) => {
    root.render(<React.StrictMode><App/></React.StrictMode>);
  });
}

// Service Worker for classic web only.
if (!isNative && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js", { updateViaCache: "none" }).then((r) => r.update()).catch(() => {});
  });
}
